/* eslint-disable linebreak-style */
import {STRAPI_API_URL} from './strapi.config';

const ORDERS_PAGE_QUERY = `
query OrdersPage($where: JSON, $start: Int!, $limit: Int!, $sort: String) {
  comandas(where: $where, start: $start, limit: $limit, sort: $sort) {
    id
    dataComanda
    clientClient
    valoareComanda
    valoareClientFinal
    stadiu
    tipProdus
    subTip
    idFirma {
      id
      denumire
      cfg1
    }
  }
  comandasConnection(where: $where) {
    aggregate {
      count
    }
  }
}
`;

const ORDER_DETAIL_QUERY = `
query OrderDetail($id: ID!) {
  comanda(id: $id) {
    id
    dataComanda
    clientClient
    valoareCatalog
    discount
    discountComisionar
    cursValutar
    valoareComanda
    valoareClientFinal
    valoareComisionar
    observatii
    adresaLivrare
    stadiu
    tipProdus
    subTip
    created_at
    updated_at
    idFirma {
      id
      denumire
      cfg1
    }
    comandarepers(sort: "nrCrt:asc") {
      id
      idComanda {
        id
      }
      nrCrt
      tipSubprodus
      lungime
      lungimeFinala
      inaltime
      inaltimeFinala
      deschidere
      culoareLamela
      culoareCaseta
      material
      codMaterial
      lungimeSnur
      actionare
      tipActionare
      actionareStDr
      ax
      culoareComponente
      optional1
      optional2
      optional3
      optional4
      console
      buc
      mp
      pretCatalog
      pretCuDiscount
      pretClientFinal
      observatii
      tipProdus
      denumireProdus
      denumireSubProdus
      denumireCuloareLamela
      denumireCuloareCaseta
      denumireMaterial
      denumireTipActionare
      denumireOptional1
      denumireOptional2
      denumireOptional3
      denumireOptional4
      continePlasaPartiala
    }
  }
}
`;

const parseNumericId = (value)=>{
  if (value === null || value === undefined) {
    return value;
  }
  const asNumber = Number(value);
  return Number.isFinite(asNumber) ? asNumber : value;
};

const normalizeOrderRecord = (record)=>{
  if (!record) {
    return null;
  }
  const normalized = {
    ...record,
    id: parseNumericId(record.id),
    comandarepers: Array.isArray(record.comandarepers) ? record.comandarepers : []
  };
  if (normalized.idFirma && typeof normalized.idFirma === 'object') {
    normalized.idFirma = {
      ...normalized.idFirma,
      id: parseNumericId(normalized.idFirma.id)
    };
  }
  normalized.comandarepers = normalized.comandarepers.map(reper=>({
    ...reper,
    id: parseNumericId(reper.id),
    idComanda: reper?.idComanda && typeof reper.idComanda === 'object'
      ? {
        ...reper.idComanda,
        id: parseNumericId(reper.idComanda.id)
      }
      : reper.idComanda
  }));
  return normalized;
};

const postGraphql = async (query, variables = {})=>{
  const response = await fetch(`${STRAPI_API_URL}/graphql`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query,
      variables
    })
  });
  if (!response.ok) {
    throw new Error(`GraphQL HTTP ${response.status}`);
  }
  const payload = await response.json();
  if (Array.isArray(payload?.errors) && payload.errors.length > 0) {
    throw new Error(payload.errors.map(error=>error.message).join('; '));
  }
  return payload.data || {};
};

export const fetchOrdersPageGraphql = async ({where, start, limit, sort})=>{
  const data = await postGraphql(ORDERS_PAGE_QUERY, {
    where,
    start,
    limit,
    sort
  });
  const items = Array.isArray(data?.comandas)
    ? data.comandas.map(order=>normalizeOrderRecord(order))
    : [];
  const total = Number(data?.comandasConnection?.aggregate?.count || 0);
  return {
    items,
    total
  };
};

export const fetchOrderDetailGraphql = async (orderId)=>{
  const data = await postGraphql(ORDER_DETAIL_QUERY, {
    id: String(orderId)
  });
  return normalizeOrderRecord(data?.comanda || null);
};
